import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ban-icon',
  templateUrl: './ban-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BanIconComponent {}
